import axios from "axios";
import paginationIndicator from "../utils/pagination-indicator";

const debug = true;

const filterPosts = (filtersSelector, loadMoreSelector, resultsContainerSelector, phpAction) => {
  const filterChipsList = document.querySelector(filtersSelector);
  const loadMoreButton = document.querySelector(loadMoreSelector);
  const resultsHolder = document.querySelector(resultsContainerSelector);

  // Hide the featured post when we start filtering
  const hideFeaturedItem = () => {
    const feat = document.querySelector('.newsroom-featured');
    if(feat){
      feat.style = 'display:none';
    }
  }

  /*
  * Clean the URL path of any pagination when switching to a new filter
  * */
  const cleanPageHref = () => {
    let url = window.location.href
    url = url.split('page/')
    window.history.pushState("object or string", "Title", url[0]);
  }

  /*
  * When the query is updated we need to check for when the results are ajaxed into the DOM then
  * dynamically update the posts "count" value so the pagination can also be updated
  * */
  const updatedResultsObserver = () => {
    const targetNode = document.querySelector('.js-results-container');
    const jsPagination = document.querySelector('.js-pagination');
    const config = { attributes: false, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const posts_per_page = targetNode.dataset.postsperpage;
          const resultNode = targetNode.querySelector('.result');
          const result = resultNode.getAttribute('data-resultscount');
          if(result) {
            let targetCategoryCount = document.querySelector('.btn__chip.active');
            targetCategoryCount.setAttribute('data-count', result);
            targetNode.dataset.max = Math.round(result / posts_per_page);
            let page = parseInt(resultsHolder.dataset.page)
            let max = parseInt(resultsHolder.dataset.max)
            if (page >= max) {
                loadMoreButton.classList.add('-hide');
                jsPagination.classList.add('-hide');
            } else {
                loadMoreButton.classList.remove('-hide');
                jsPagination.classList.remove('-hide');
            }
            paginationIndicator();
          }
        }
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config)
  }

  // Results, Reports & Presentations page also has a <select> for year
  // select menu options do not have click events so will need onChange
  const selectMenu = document.getElementById('results-year')

  if (filterChipsList) {

    const filterChips = [...filterChipsList.querySelectorAll(".btn__chip")];

    const ajaxGetMorePosts = (e, value = null, cat = null) => {

      e.preventDefault();
      hideFeaturedItem();

      resultsHolder.setAttribute('data-page', '1');
      const target = e.target;
      let targetCategory = target.getAttribute("data-slug");
      let targetCategoryCount;
      targetCategoryCount = target.getAttribute("data-count");

      if (target.nodeName === "BUTTON") {
        for (var i = 0; i < filterChips.length; i++) {
          if (filterChips[i] !== this) {
            filterChips[i].classList.remove("active");
          }
        }
        target.classList.add("active");
      }

      //TODO: if e.target.classList.contains('js-year-filter') then we need to get the slug and count values from the active filter chip
      if(target.classList.contains('js-year-filter')) {
        targetCategory = document.querySelector('.btn__chip.active').getAttribute('data-slug');
        targetCategoryCount = document.querySelector('.btn__chip.active').getAttribute('data-count');
      }
      // Has a year already been selected
      let year;
      if(selectMenu) {
        year = selectMenu.options[selectMenu.selectedIndex].text;
      }
      e.stopPropagation();

      let current_page = document.querySelector(".js-results-container").dataset.page;
      let posts_per_page = document.querySelector(".js-results-container").dataset.postsperpage;
      let blog_id = document.querySelector(".js-results-container").dataset.blogid;
      let max_pages;

      if(targetCategory === 'all') {
        max_pages = document.querySelector(".js-results-container").dataset.all;
      } else {
        max_pages = Math.round(targetCategoryCount / posts_per_page);
      }

      let _cat;
      if( cat !== null ) {
        _cat = cat;
      } else {
        _cat = targetCategory;
      }

      // Update 'data-max' value in DOM with max value for current category
      document.querySelector(".js-results-container").dataset.max = max_pages;
      paginationIndicator();

      if (resultsHolder.dataset.page == resultsHolder.dataset.max) {
          loadMoreButton.classList.add('-hide');
      } else {
          loadMoreButton.classList.remove('-hide');
      }
      // Create search params
      let params = new URLSearchParams();
      params.append("action", phpAction); // the PHP query function
      params.append("current_page", current_page);
      params.append("max_pages", max_pages);
      params.append("category", _cat);
      params.append("posts_per_page", posts_per_page);
      params.append('year', value)
      params.append("blog_id", blog_id);

      if(debug){
        console.log("filterPosts", 'params', targetCategory);
      }

      // Display loading spinner when ajax request is being made
      axios.interceptors.request.use(function(config) {
        // Do something before request is sent
        document.querySelector('.spinner-outer').classList.add('-loading', '-pos-top');
        loadMoreButton.classList.add('-hide');

        return config;
      }, function(error) {
        return Promise.reject(error);
      });
      // Remove loading spinner when done
      axios.interceptors.response.use(function(response) {
        // Do something with response data
        document.querySelector('.spinner-outer').classList.remove('-loading', '-pos-bottom');
        loadMoreButton.classList.remove('-hide');

        return response;
      }, function(error) {
        return Promise.reject(error);
      });

      axios.post("/wp-admin/admin-ajax.php", params).then((res) => {
        if(debug){
          console.log("filterPosts", { res });
        }
        let posts_list = document.querySelector(resultsContainerSelector);
        posts_list.innerHTML = res.data;

      });
    }

    filterChipsList.addEventListener("click", (e) => {
      cleanPageHref()
      let year;
      if(selectMenu){
        year = selectMenu.options[selectMenu.selectedIndex].text
      } else {
        year = null
      }
      ajaxGetMorePosts(e, year)
    }); // end click event

    if( selectMenu ) {
      updatedResultsObserver();
      selectMenu.addEventListener('change', (e) => {
        let category = filterChipsList.querySelector('.active').dataset.slug
        let year = selectMenu.options[selectMenu.selectedIndex].text
        cleanPageHref()
        ajaxGetMorePosts(e, year, category)
      })
    }
  }
};

// Newsroom filters
const newsroom = document.querySelector('.newsroom-main');
// Results, Reports & Presentations filters
const resultsReports = document.querySelector('.js-results-reports')
if(newsroom){
  filterPosts(
      '.filter-chips',
      '#js-load-more-posts',
      '.js-results-container',
      'sevendots_filter_news_posts');
}
if(resultsReports){
  filterPosts('.filter-chips',
      '#js-load-more-posts',
      '.js-results-container',
      'sevendots_filter_resultsreports');
}
